import axios from 'axios';
import { RequestParameter } from '@/services/zipcloud/types';

const baseUrl = 'https://zipcloud.ibsnet.co.jp/api/search';

export default class Zipcloud {
  public async search(params: RequestParameter) {
    const queryString = Object.entries(params)
      .map(e => `${e[0]}=${e[1]}`)
      .join('=');
    const requestUri = [baseUrl, queryString].join('?');
    return await axios.get(requestUri);
  }
}
